import React, { Component } from "react";
import { Button, AppBar, Toolbar, Typography, IconButton } from "material-ui";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import AvatarMenu from "../components/AvatarMenu";
import { logout } from "../actions/login.actions";
import NotificationsMenu from "./NotificationsMenu";
import ArrowBackIcon from "material-ui-icons/ArrowBack";
import AccountCircleIcon from "material-ui-icons/AccountCircle";
import { push } from "react-router-redux";
import { openFeedbackDialog } from "../actions/feedback.actions";
import FeedbackDialog from "./FeedbackDialog";
import { Link } from "react-router-dom";
import AppLanguageSelect from "../components/AppLanguageSelect";

const styleSheet = theme => ({
    logoFlex: {
        flex: 1,
        cursor: "pointer"
    },
    circleIcon: {
        marginRight: theme.spacing.unit
    },
    button: {
        margin: `${theme.spacing.unit}px ${theme.spacing.unit}px ${theme.spacing
            .unit}px ${2 * theme.spacing.unit}px`
    },
    buttonIcon: {
        marginRight: theme.spacing.unit
    },
    feedbackButton: {
        marginRight: -theme.spacing.unit
    },
    constrainedMargins: {
        width: "calc(100% - 48px)",
        maxWidth: 1000,
        margin: "auto"
    },
    backButton: {
        marginLeft: -12,
        marginRight: 20
    },
    showText: {
        display: "none"
    },
    "@media (min-width: 400px)": {
        showText: {
            display: "inline"
        }
    }
});

class Header extends Component {
    static propTypes = {
        userSettings: PropTypes.object,
        classes: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired
    };

    renderLoggedInComponents() {
        const { userSettings, location, classes, t } = this.props;
        const { pathname } = location;

        if (pathname === "/") {
            return [
                <AppLanguageSelect key="langaugeSelectApp" />,
                <Button
                    key="signinButton"
                    style={{ color: "white" }}
                    component={Link}
                    to="/login">
                    <AccountCircleIcon className={classes.circleIcon} />
                    <span className={classes.showText}>
                        {t("appBar.Sign in")}
                    </span>
                </Button>
            ];
        }
        if (
            pathname === "/" ||
            pathname === "/login" ||
            pathname.startsWith("/setup") ||
            !userSettings.apiToken
        ) {
            return;
        }

        return [
            <NotificationsMenu key="notif-menu" />,
            <AvatarMenu
                handleLogout={this.handleLogout}
                handleProfile={this.handleProfile}
                handleFeedback={this.handleFeedbackButton}
                key="avatarMenu"
                userSettings={userSettings}
            />
        ];
    }

    handleLogout = () => {
        this.props.dispatch(logout());
    };

    handleProfile = () => {
        const { dispatch, userSettings } = this.props;
        dispatch(push(`/profile/${userSettings.id}`));
    };

    onLogoClick = () => {
        const { dispatch, userSettings, location: { pathname } } = this.props;
        if (userSettings.loggedIn && pathname !== "/feed") {
            dispatch(push("/feed"));
        }
    };

    handleBackButtonPress = () => {
        const { dispatch, userSettings } = this.props;
        // TODO: Examine this behavior a bit more.  Should I look at the history
        // stack in this case?
        if (userSettings.loggedIn) {
            dispatch(push("/feed"));
        } else {
            dispatch(push("/"));
        }
    };

    renderBackButton() {
        const { classes, location } = this.props;
        const { pathname } = location;
        if (
            pathname !== "/" &&
            pathname !== "/feed" &&
            !pathname.startsWith("/setup")
        ) {
            return (
                <IconButton
                    className={classes.backButton}
                    color="inherit"
                    onClick={this.handleBackButtonPress}
                    aria-label="Back">
                    <ArrowBackIcon />
                </IconButton>
            );
        }
    }

    handleFeedbackButton = () => {
        this.props.dispatch(openFeedbackDialog());
    };

    render() {
        const { classes, location } = this.props;
        const { pathname } = location;
        let style =
            pathname === "/" || pathname === "/login"
                ? { color: "white" }
                : { backgroundColor: "white" };
        return (
            <AppBar position="fixed" style={style}>
                <FeedbackDialog />
                <Toolbar className={classes.constrainedMargins}>
                    {this.renderBackButton()}
                    <Typography
                        onClick={this.onLogoClick}
                        type="title"
                        color="inherit"
                        className={classes.logoFlex}>
                        MODOLE
                    </Typography>
                    {this.renderLoggedInComponents()}
                </Toolbar>
            </AppBar>
        );
    }
}

function mapStateToProps({ router: { location }, userSettings }) {
    return {
        userSettings,
        location
    };
}

export default wrapComponent(Header, styleSheet, mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/AppBar.jsx